require('./_default');
require('./bootstrap');
require('./frontend/address');
require('./frontend/bikeshops');
require('./frontend/checkout');
require('./frontend/courses');
require('./frontend/members');
require('./frontend/start');

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}
function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

window.gSubmit = function(token) {
  document.getElementById("footer-contact").submit();
}

$(function() {
  $('div.cookieinfo-close').bind('click', function(e) {
		$('.cookieinfo').animate({bottom:-1000, opacity:0}, 800);
		createCookie('cookie-msg', 'true', 30);
  });

  $('.modal.ws-shown').modal('show');
});
